<template>
  <div
    class="container navigate-left-change"
    :class="{ hasLeft: hasLeft, collapsed: isCollapse }"
  >
    <div style="display: none;">{{ reloadInfo }}</div>
    <div
      class="left-wrapper nav-left-menu"
      v-show="hasLeft"
    >
      <el-scrollbar class="auto-height-scrollbar dark">
        <el-menu
          ref="leftMenu"
          :collapse="isCollapse"
          :collapse-btn="true"
          theme="dark"
          wrap-scroll
          @open="onMenuFold"
          @close="onMenuFold"
          @click-collapse="onClickCollapseBtn"
        >
          <template v-for="menu in targetChildren">
            <el-submenu
              v-if="!menu.fullUrl&&menu.children && menu.children.length && menu.isShow === 0"
              :index="menu._path"
              :title="menu.name"
              :key="menu._path"
            >
              <img
                class="icon"
                slot="icon"
                :src="menu.iconInfo.path"
                :onerror="defaultIcon"
              />
              <el-menu-item
                v-for="sub in menu.children"
                v-show="sub.isShow === 0"
                :index="sub._path"
                :key="sub.menuId"
                @click="onMenuSelect(sub)"
              >
                {{ sub.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-else
              v-show="menu.isShow === 0"
              :index="menu._path"
              :key="menu._path"
              @click="onMenuSelect(menu)"
            >
              <img
                slot="icon"
                class="icon"
                :src="menu.iconInfo.path"
                :onerror="defaultIcon"
              />
              {{ menu.name }}
            </el-menu-item>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
    <div
      class="right-wrapper"
      id="rightWrapper"
    >
      <tab-iframe
        v-for="menu in tabMenus"
        :key="menu.menuId"
        :menu="menu"
        class="tab-default"
        :class="{'tab-show':activeTabMenu === menu.menuId}"
      ></tab-iframe>
      <!-- v-show="activeTabMenu === menu.menuId" -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { autoCloseMenu } from 'utils/mixin'
import _ from 'lodash'
import tabIframe from './tab-iframe'
export default {
  name: 'navigate-left-change',
  props: {
    userName: String
  },
  components: { tabIframe },
  computed: {
    ...mapGetters(['appMenus', 'tabMenus', 'activeTabMenu']),
    newMenus () {
      let temp = JSON.parse(JSON.stringify(this.tabMenus))
      return temp
    },
    reloadInfo () {
      this._setInfo()
      return this.activeTabMenu
    },
    activeMenu () {
      this.seekMenuRoots(this.activeTabMenu, true)
      let _menuMap = this.menuMap
      _menuMap = _menuMap.reverse()
      let _map = {
        firstMenu: null,
        secondMenu: null,
        thirdMenu: null,
        targetMenu: null
      }
      if (_menuMap[0]) {
        _map.firstMenu = this._getMenu(this.appMenus, _menuMap[0])
        if (!_map.firstMenu) {
          this.tabMenus.forEach(item => {
            if (item.menuId === _menuMap[0]) {
              _map.firstMenu = item
            }
          })
        }
        _map.targetMenu = _map.firstMenu
      }
      if (_map.firstMenu) {
        if (_menuMap[1]) {
          _map.secondMenu = this._getMenu(
            _map.firstMenu.children,
            _menuMap[1]
          )
          _map.targetMenu = _map.secondMenu
        } else if (_map.firstMenu.children.length) {
          _map.secondMenu = _map.firstMenu.children[0]
        }
      }
      if (_map.secondMenu) {
        if (_menuMap[2]) {
          _map.thirdMenu = this._getMenu(
            _map.secondMenu.children,
            _menuMap[2]
          )
          _map.targetMenu = _map.thirdMenu
        } else if (_map.secondMenu.children.length) {
          _map.thirdMenu = _map.secondMenu.children[0]
        }
      }
      return _map
    },
    hasLeft () {
      return this.activeMenu.targetMenu && this.activeMenu.targetMenu._hasChild && !this.activeMenu.targetMenu.fullUrl
    },
    targetChildren () {
      return this.activeMenu.targetMenu
        ? this.activeMenu.targetMenu.children
        : []
    },
    tlncParams () {
      return this.$storage.get('tlncParams')
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`,
      isCollapse: false,
      showUrl: '',
      menuMap: []
    }
  },
  methods: {
    seekMenuRoots (_value, flag) {
      if (flag) this.menuMap = []
      const findMenu = (arr, value, key) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i][key] === value) {
            return arr[i]
          }
          if (arr[i]._hasChild) {
            let _res = findMenu(arr[i].children, value, key)
            if (_res) return _res
          }
        }
        return null
      }
      let menu = findMenu(this.appMenus, _value, 'menuId')
      if (menu) {
        this.menuMap.push(menu.menuId || '')
        if (menu.parentId !== 'menu_app') {
          this.seekMenuRoots(menu.parentId)
        }
      }
    },
    _getMenu (arr, id) {
      let _menu = null
      if (!arr || arr.length < 0 || !id) return _menu
      arr.forEach(item => {
        if (item.menuId === id) {
          _menu = item
        }
      })
      return _menu
    },
    _setInfo () {
      let _target = this.tabMenus.filter(
        item => item.menuId === this.activeTabMenu
      )[0]
      if (!_target || !_target._info) return
      this.isCollapse = _target._info.isCollapse
      this.showUrl = _target._info.showUrl
      if (this.$refs.leftMenu) {
        this.$refs.leftMenu.activeIndex = _target._info.activeIndex
        this.$refs.leftMenu.openedMenus = JSON.parse(
          JSON.stringify(_target._info.openedMenus)
        )
      }
    },
    _updateInfo () {
      this.updateTabMenuItem({
        isCollapse: this.isCollapse,
        showUrl: this.showUrl,
        activeIndex: this.$refs.leftMenu.activeIndex,
        openedMenus: this.$refs.leftMenu.openedMenus
      })
    },
    onClickCollapseBtn (flag) {
      if (flag) {
        this.isCollapse = flag
      } else {
        this.isCollapse = !this.isCollapse
      }
      this.updateTabMenuItem({
        isCollapse: this.isCollapse,
        showUrl: this.showUrl,
        activeIndex: this.$refs.leftMenu.activeIndex,
        openedMenus: this.$refs.leftMenu.openedMenus
      })
    },
    onMenuSelect: _.debounce(async function (menu) {
      this.showUrl = menu.fullUrl
      this._updateInfo()
    }, 600),
    onMenuFold () {
      this._updateInfo()
    },
    ...mapActions(['updateTabMenuItem'])
  },
  mounted () {
    this._setInfo()
    this._autoCloseMenu()
    top.window.extendScreen_closeMenu = this.onClickCollapseBtn
  },
  mixins: [autoCloseMenu]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.navigate-left-change.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .right-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    .tab-default {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      opacity: 0;
      z-index: 1;
      &.tab-show {
        z-index: 2;
        opacity: 1;
      }
    }
    iframe {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  &.hasLeft {
    .left-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 240px;
      background: #252525;
      overflow: auto;
      /deep/ .el-scrollbar__wrap {
        position: absolute !important;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        .el-menu {
          .el-menu-icon {
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .right-wrapper {
      left: 240px;
    }
    &.collapsed {
      .left-wrapper {
        width: 48px;
      }
      .right-wrapper {
        left: 48px;
      }
    }
  }
}
</style>
